import { render, staticRenderFns } from "./phoneCodeStyle.vue?vue&type=template&id=3943ec62&scoped=true"
import script from "./phoneCodeStyle.vue?vue&type=script&lang=js"
export * from "./phoneCodeStyle.vue?vue&type=script&lang=js"
import style0 from "./phoneCodeStyle.vue?vue&type=style&index=0&id=3943ec62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3943ec62",
  null
  
)

export default component.exports